import { render, staticRenderFns } from "./proofTags.vue?vue&type=template&id=197c12d2"
import script from "./proofTags.vue?vue&type=script&lang=js"
export * from "./proofTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports